import React, { useState, useEffect } from 'react';
import {Observer} from "mobx-react-lite";
import clsx from "clsx";
import { useCommonContext } from '../../../../contexts/CommonContext';
import PackageTabStore from './PackageTabStore';
import { useStyles } from './PackageTab.style';
import { CurrencyModule } from '../../../../util/Currency';
import Currency from '../../../../entities/Currency';
import ProfitsTabProperties from '../ProfitsTabProperties';

const PackageTab: React.FC<ProfitsTabProperties> = ({
    from,
    to
}) => {

    const classes = useStyles();
    const commonStore = useCommonContext();
    const [store] = useState(() => new PackageTabStore(commonStore, from, to));

    useEffect(() => {
        store.setDateRange(from, to);
        store.loadPackageOrders();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [from, to]);

    return <Observer>
        {() => (
            <div className={classes.article_tab_container}>
                <div className={classes.article_summary}>
                    <div className={classes.summary_item}>
                        <span className={classes.summary_label}>Total de Órdenes:</span>
                        <span className={classes.summary_value}>
                            {store.articleSummary?.ordersAmount || 0}
                        </span>
                    </div>
                    <div className={classes.summary_item}>
                        <span className={classes.summary_label}>Costo Total:</span>
                        <span className={classes.summary_value}>
                            {CurrencyModule.format(store.articleSummary?.totalPurchaseCost || 0, Currency.USD)}
                        </span>
                    </div>
                    <div className={classes.summary_item}>
                        <span className={classes.summary_label}>Venta Total:</span>
                        <span className={classes.summary_value}>
                            {CurrencyModule.format(store.articleSummary?.totalServiceCost || 0, Currency.USD)}
                        </span>
                    </div>
                    <div className={classes.summary_item}>
                        <span className={classes.summary_label}>Ganancia:</span>
                        <span className={clsx(
                            classes.summary_value,
                            (store.articleSummary?.totalProfit || 0) >= 0
                                ? classes.profit_positive
                                : classes.profit_negative
                        )}>
                            {CurrencyModule.format(store.articleSummary?.totalProfit || 0, Currency.USD)}
                        </span>
                    </div>
                </div>

                {/* Lista de Órdenes con Expandible */}
                <div className={classes.orders_list}>
                    {store.isLoading ? (
                        <div className={classes.loading}>Cargando órdenes...</div>
                    ) : store.articleSummary && store.articleSummary.orders!!.length > 0 ? (
                        store.articleSummary.orders!!.map((order) => (
                            <div key={order.id} className={classes.order_item}>
                                <div className={classes.order_header}>
                                    <div className={classes.order_header_left}>
                                        <div className={classes.order_number}>
                                            {order.orderNumber}
                                        </div>
                                    </div>
                                    <div className={classes.order_header_right}>
                                        <div className={classes.order_profit}>
                                            <span className={classes.profit_label}>Venta:</span>
                                            <span className={classes.profit_value}>
                                                {CurrencyModule.format(order.serviceCost || 0, Currency.USD)}
                                            </span>
                                        </div>
                                        <div className={classes.order_profit}>
                                            <span className={classes.profit_label}>Costo:</span>
                                            <span className={classes.profit_value}>
                                                {CurrencyModule.format(order.purchaseCost || 0, Currency.USD)}
                                            </span>
                                        </div>
                                        <div className={classes.order_profit}>
                                            <span className={classes.profit_label}>Ganancia:</span>
                                            <span className={clsx(
                                                classes.profit_value,
                                                classes.profit_positive
                                            )}>
                                                {CurrencyModule.format(Math.max(0, (order.serviceCost || 0) - (order.purchaseCost || 0)), Currency.USD)}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))
                    ) : (
                        <div className={classes.empty_state}>
                            No hay órdenes de artículos en el período seleccionado
                        </div>
                    )}
                </div>
            </div>
        )}
    </Observer>
}

export default PackageTab;